export default __webpack_public_path__ + "static/media/books.4c142cfe.png";